import React from "react";
import { useState, useEffect } from "react";

const Timer = (props) => {
    const { initialMinute = 0, initialSeconds = 0, initialHours = 0 } = props;
    const [minutes, setMinutes] = useState(initialMinute);
    const [seconds, setSeconds] = useState(initialSeconds);
    const [hours, setHours] = useState(initialHours);

    useEffect(() => {
        if (initialMinute < 0 || initialSeconds < 0 || initialHours < 0) {
            props.onClosing(0, 0);
        } else {
            setSeconds(initialSeconds);
            setMinutes(initialMinute);
            setHours(initialHours);
        }
    }, [props]);

    useEffect(() => {
        let myInterval = setInterval(() => {
            if (props.decrement) {
                let allSeconds = seconds + minutes * 60 + hours * 60 * 60;
                if (allSeconds < 300) {
                    props.onClosing(minutes, seconds);
                }
                setSeconds(seconds - 1);
                if (seconds === 0) {
                    setMinutes(minutes - 1);
                    setSeconds(59);
                }
                if (minutes === 0) {
                    setMinutes(59);
                    setHours(hours - 1);
                }
            } else {
                setSeconds(seconds + 1);
                if (seconds === 59) {
                    setMinutes(minutes + 1);
                    setSeconds(0);
                }
                if (minutes === 59) {
                    setMinutes(0);
                    setHours(hours + 1);
                }
            }
        }, 1000);
        return () => {
            clearInterval(myInterval);
        };
    });

    return (
        <p className="text-left">
            <span className="duration">
                {`${hours.toString().padStart(2, "0")} : ${minutes
                    .toString()
                    .padStart(2, "0")} : ${seconds
                    .toString()
                    .padStart(2, "0")}`}
            </span>
        </p>
    );
};

export default Timer;
